
import { i18nText } from '@/locales';
import { maxLength } from 'vuelidate/lib/validators';
import { LoyaltySubscriptionTypeAddRequestType, LoyaltySubscriptionTypeServices } from './loyaltySubscription.types';

export class SubscribtionTypeServices {
    id: number | null
    salon_id?: number | null;
    all: boolean
    category: number | null
    quantity: number | null
    constructor() {
        this.id = null
        this.salon_id = null
        this.all = false
        this.category = null
        this.quantity = 1
    }
}
export class loyaltySubscriptionTypeForm {
    id?: number | null;
    salon_id?: number | null;
    name: string;
    price: number | null;
    validity: number | null;
    membership_freezing: boolean;
    membership_freezing_period: number | null;
    online_pay_relevance: boolean;
    services: Array<LoyaltySubscriptionTypeServices>

    setFormData(data: LoyaltySubscriptionTypeAddRequestType): void {
        this.id = data.id
        this.salon_id = data.salon_id
        this.name = data.name
        this.price = data.price
        this.validity = data.validity
        this.membership_freezing = data.membership_freezing
        this.membership_freezing_period = data.membership_freezing_period
        this.online_pay_relevance = data.online_pay_relevance
        this.services = data.services
    }
    constructor() {
        this.name = ''
        this.salon_id = 0;
        this.price = 0
        this.validity = null
        this.membership_freezing = false
        this.membership_freezing_period = null
        this.online_pay_relevance = false
        this.services = []
    }
}
export const FormRules = {
    price: [{required: true, type: 'number', min: 0.01, message: i18nText('Укажите стоимость больше нуля'), trigger: 'change'}],
    name: [
        { required: true, message: i18nText("Укажите название"), trigger: 'change' },
        { validator: (field: unknown, value: string): boolean => value.toString().length <= 255, message: i18nText("Количество символов не должно превышать 255 знаков"), trigger: 'change'}
    ],
    validity: [{ required: true, type: 'integer', min: 1, max: 12, transform: (value: unknown) => Number(value), message: i18nText("Укажите срок от 1 до 12 месяцев"), trigger: 'change' }],
};
